import { Network } from '@capacitor/network';
import { edgeFetch } from './cloud';

export type LearningEvent = {
  id?: string;
  type: 'vocabulary_attempt' | 'skill_attempt' | 'lesson_complete' | 'boss_complete' | 'screen_view';
  createdAt?: string;
  skill?: string;
  objectId?: string;
  correct?: boolean;
  latencyMs?: number;
  day?: number;
  score?: number;
  passed?: boolean;
  reviewDebt?: number;
  courseDate?: string;
  evidenceType?: 'meaning_recall' | 'form_recall' | 'listening' | 'context' | 'production';
};

const QUEUE_KEY = 'ef365-event-queue-v1';
let flushing = false;

function makeId() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

function readQueue(): LearningEvent[] {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) ?? '[]') as LearningEvent[]; }
  catch { return []; }
}
function writeQueue(queue: LearningEvent[]) { localStorage.setItem(QUEUE_KEY, JSON.stringify(queue.slice(-500))); }

export async function queueLearningEvent(event: LearningEvent) {
  const queue = readQueue();
  queue.push({ ...event, id: event.id ?? makeId(), createdAt: event.createdAt ?? new Date().toISOString() });
  writeQueue(queue);
  void flushLearningEvents();
}

export async function flushLearningEvents() {
  if (flushing) return false;
  flushing = true;
  try {
    const status = await Network.getStatus().catch(() => ({ connected: navigator.onLine }));
    if (!status.connected) return false;
    const queue = readQueue();
    if (!queue.length) return true;
    const batch = queue.slice(0, 50);
    const response = await edgeFetch('/learning-event', { method: 'POST', body: JSON.stringify({ events: batch }) }, true);
    if (!response.ok) return false;
    writeQueue(queue.slice(batch.length));
    if (readQueue().length) window.setTimeout(() => void flushLearningEvents(), 500);
    return true;
  } catch { return false; }
  finally { flushing = false; }
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => void flushLearningEvents());
}
